import ProductLink from '@components/common/ProductLink';
import ProductNotifyMeModal from '@moncler/components/product/ProductNotifyMeModal';
import ProductSelectionColorLink from '@moncler/components/product/ProductSelectionColorLink';
import ProductSelectionSizes from '@moncler/components/product/ProductSelectionSizes';
import ProductWishlistToggle from '@moncler/components/product/ProductWishlistToggle';
import ModalDialog from '@ui/modal/ModalDialog';
import analytics from '@utils/analytics';
import einsteinutils from '@utils/einsteinutils';
import { getDefferedTransition } from '@utils/landingAnimations';
import { getColorVariations, getProductMasterId, getSizeVariations } from '@utils/product';
import classNames from 'classnames';
import { motion } from 'framer-motion';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '@common/utils/api';
import DwMarker from '@common/components/common/DwMarker';
import { handleTileNavigation } from '@utils/useMousePosition';
import ProductImage from '@moncler/components/product/ProductImage';
import ProductLabels from '@moncler/components/product/ProductLabels';
import ProductPrice from '@moncler/components/product/ProductPrice';
import ProductTileCarousel from '@moncler/components/product/ProductTileCarousel';
import LookProduct from './LookProduct';
import LoginModal from '@components/login/LoginModal';
import useBreakpoint from '@utils/useBreakpoint';
const isMobile = window.isMobile();
const ProductTile = (props) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const { t } = useTranslation();
    const tileRef = useRef(null);
    const tileInfo = useRef(null);
    const sbl = useRef(null);
    const containerRef = useRef(null);
    const productObject = typeof props.product === 'string' ? JSON.parse(props.product) : props.product;
    //only for editorial component
    const hoverDifferent = props.hoverDifferent;
    const introCards = props.introCards;
    const noClickTracking = props.noClickTracking;
    const isCarouselVersion = props.withCarousel;
    const swatchChange = window.tileColorSwatch;
    const [isMouseOver, setIsMouseOver] = useState(false);
    const [isOver, setIsOver] = useState(false);
    const [product, setProduct] = useState();
    const { status, navigation } = handleTileNavigation(tileRef);
    const [originalUuid, setOriginalUuid] = useState(null);
    const [firstColorId, setFirstColorId] = useState(null);
    const [currentSize, setCurrentSize] = useState();
    const [currentColor, setCurrentColor] = useState();
    const [showColorSwatch, setShowColorSwatch] = useState(true);
    const [forceOpenSizeSelector, setForceOpenSizeSelector] = useState(false);
    const [isDesktop, setIsDesktop] = useState(false);
    const [showAddToBagMessage, setShowAddToBagMessage] = useState(false);
    const [shopByLookHeight, setShopByLookHeight] = useState(0);
    const [lookProductInfoHeight, setLookProductInfoHeight] = useState(0);
    const [variantPrice, setVariantPrice] = useState();
    const [openShopByLook, setOpenShopByLook] = useState(false);
    const [shopByLookNotify, setShopByLookNotify] = useState(false);
    const [loginOpen, setLoginOpen] = useState(false);
    const currentBreakpoint = useBreakpoint();
    useEffect(() => {
        //@ts-ignore disable-next-line
        if (currentBreakpoint >= window.mqObj.lg) {
            setIsDesktop(true);
        }
        else {
            setIsDesktop(false);
        }
    }, [currentBreakpoint]);
    useEffect(() => {
        setIsOver(status === 'IN');
        setIsMouseOver(status === 'IN' && navigation === 'mouse');
    }, [status]);
    useEffect(() => {
        var _a, _b, _c, _d, _e;
        if (product && !originalUuid) {
            setOriginalUuid(product.uuid);
        }
        if (product && !firstColorId) {
            let VariationColors = (_b = (_a = product === null || product === void 0 ? void 0 : product.variationAttributes) === null || _a === void 0 ? void 0 : _a.find((v) => v.attributeId == 'color')) === null || _b === void 0 ? void 0 : _b.values;
            let selectedColor = (_c = VariationColors === null || VariationColors === void 0 ? void 0 : VariationColors.find((v) => v.selected)) === null || _c === void 0 ? void 0 : _c.id;
            setFirstColorId(selectedColor);
        }
        if (product) {
            let colorSwatchLenght = (_e = (_d = product === null || product === void 0 ? void 0 : product.variationAttributes) === null || _d === void 0 ? void 0 : _d.find((v) => v.attributeId == 'color')) === null || _e === void 0 ? void 0 : _e.values.length;
            setShowColorSwatch((colorSwatchLenght > 1 && swatchChange) || !swatchChange);
        }
    }, [product]);
    // gestisco l'assegnazione di product al caricamento
    useEffect(() => {
        setProduct(productObject);
        const colorVariations = getColorVariations(productObject);
        const selectedColor = colorVariations.find((v) => v.selected);
        setCurrentColor(selectedColor ? selectedColor : colorVariations[0]);
        // sono in una tile in un carosello, rimuovo lo skeleton loading
        if (props.componentUuid) {
            setTimeout(() => {
                document.querySelector(`[data-option-uuid="${props.componentUuid}"]`).classList.remove('skeleton-loading');
            }, 500);
        }
    }, [props.product]);
    useEffect(() => {
        if (!(product === null || product === void 0 ? void 0 : product.id)) {
            return;
        }
        if (props.type == 'LOOKPRODUCT' || props.type == 'PLPLOOK') {
            einsteinutils.trackProductSet(product.id);
            return;
        }
        if (props.type == 'RECS' || props.type == 'LOOKTILE' || props.type == 'CURATORS') {
            // tracked directly in einsteinutils
            return;
        }
        if (product.isobject) {
            tileRef.current.insertAdjacentHTML('afterbegin', product.isobject);
        }
        einsteinutils.trackProductInCategory(product.id, props.category, props.sortingrule);
    }, [product]);
    // gestisco tile info in absolute per LOOKPRODUCT
    useEffect(() => {
        let timeoutId;
        if (product && (isDesktop || props.isLookCarousel) && props.type == 'LOOKPRODUCT') {
            timeoutId = setTimeout(() => {
                if (tileInfo.current) {
                    setLookProductInfoHeight(tileInfo.current.offsetHeight);
                }
            }, 100);
        }
        else {
            setLookProductInfoHeight(0);
        }
        return () => {
            clearTimeout(timeoutId);
        };
    }, [isDesktop, product, props.type]);
    useEffect(() => {
        if (props.showLook != undefined && !props.showLook && shopByLookHeight != 0) {
            setShopByLookHeight(0);
        }
    }, [props.showLook]);
    const changeSize = (variation) => {
        var _a;
        setCurrentSize(variation);
        analytics.productImpressionsChange(product, props.index, undefined, variation.id, props.actionList);
        analytics.sizeSelectionPlp(product, variation === null || variation === void 0 ? void 0 : variation.id);
        // qui non va cambiato il prodotto, va solo salvata la taglia selezionata che serve per l'add to cart
        if (((_a = product === null || product === void 0 ? void 0 : product.price) === null || _a === void 0 ? void 0 : _a.type) === 'range') {
            // prezzo diverso per taglia
            api.variantPrice(`${product.masterId}${currentColor.id}${variation.id}`).then((data) => setVariantPrice(data));
        }
    };
    const sizeVariations = useMemo(() => {
        let sizeVariations = getSizeVariations(product);
        // se è taglia unica la imposto
        if (sizeVariations.length == 1) {
            setCurrentSize(sizeVariations[0]);
        }
        else if (currentSize) {
            // check se esiste la taglia selezionata e riseleziono per aggiornare lo stock
            if (sizeVariations.find((el) => el.value == currentSize.value)) {
                const sizeUpdated = sizeVariations.find((el) => el.value == currentSize.value);
                setCurrentSize(sizeUpdated);
            }
            else {
                setCurrentSize(undefined);
            }
        }
        return sizeVariations;
    }, [product]);
    const colourVariations = useMemo(() => {
        return getColorVariations(product).map((value) => {
            return Object.assign(Object.assign({}, value), { groupPid: product.masterId + value.id });
        });
    }, [product]);
    const showWishlistBtn = useMemo(() => {
        return ['PLP', 'RECS', 'CURATORS', 'LOOKPRODUCT', 'SEARCH'].indexOf(props.type) != -1 && currentColor && !(product === null || product === void 0 ? void 0 : product.isMbm) && !props.hideWishlistBtn;
    }, [product, currentColor, props.hideWishlistBtn, props.type]);
    const isNotNativeInput = (element) => {
        const tags = ['button', 'a', 'input', 'label'];
        return tags.indexOf(element.tagName.toLowerCase()) < 0;
    };
    const triggerClick = (e) => {
        var _a;
        if (e.type === 'keydown' && e.key !== 'Enter') {
            return false;
        }
        const target = e.target;
        // We want to keep original behavior for native clickable elements
        if (isNotNativeInput(target) &&
            isNotNativeInput(target.parentElement) &&
            !target.closest('.btn-label') &&
            !target.closest('.wishlist-icon') &&
            !target.closest('.swiper-pagination-clickable') &&
            !target.closest('.selector__menu')) {
            (_a = target.closest('.product-tile').querySelector('.product-tile__link')) === null || _a === void 0 ? void 0 : _a.click();
        }
    };
    const changeColor = (colorVariation) => {
        if (!colorVariation || product.id.endsWith(colorVariation.id)) {
            return;
        }
        setCurrentColor(colorVariation);
        analytics.productImpressionsChange(product, props.index, colorVariation.id, undefined);
        let baseId = getProductMasterId(product);
        api.getProductTile(baseId + colorVariation.id, firstColorId).then((data) => setProduct(data));
    };
    const isComingSoon = (product === null || product === void 0 ? void 0 : product.isComingSoon) === 2;
    const justAddedMessage = useMemo(() => {
        return (showAddToBagMessage && (React.createElement("span", { className: "visually-hidden", role: "alert" }, t('bag.justadded'))));
    }, [showAddToBagMessage]);
    const colorSelection = () => {
        return (React.createElement(ProductSelectionColorLink, { tileType: "PLP", product: product, variationValues: colourVariations, currentId: currentColor === null || currentColor === void 0 ? void 0 : currentColor.id, compressColorSwatch: props.compressColorSwatch, onChangeVariation: (colorVariation) => {
                changeColor(colorVariation);
            }, originalUuid: originalUuid, isComingSoon: isComingSoon, isBoutiqueExclusive: product === null || product === void 0 ? void 0 : product.isBoutiqueExclusive }));
    };
    const productInfo = () => {
        var _a, _b;
        return (React.createElement(motion.div, { ref: tileInfo, transition: getDefferedTransition(isDesktop ? (props.index < 4 ? 1 : 2) : props.index < 2 ? 1 : props.index < 4 ? 2 : 3), initial: { opacity: props.index < 8 ? 0 : 1 }, animate: { opacity: props.hasAnimation && !props.startAnimation ? 0 : 1 }, className: classNames('product-tile__info', 'single-slide__labels', { lookinfo: props.type === 'LOOKPRODUCT' }), style: { position: lookProductInfoHeight != 0 ? 'absolute' : undefined } },
            React.createElement("div", null,
                (!props.hidelabels || props.showonlyname) && (product === null || product === void 0 ? void 0 : product.productName) && productName(),
                !props.hideprice && (React.createElement("span", { "aria-hidden": props.type === 'LOOKPRODUCT', className: "product-tile__price" }, product.isGiftCard ? React.createElement(ProductPrice, { basePrice: ((_b = (_a = product === null || product === void 0 ? void 0 : product.gcLimits) === null || _a === void 0 ? void 0 : _a.minValue) === null || _b === void 0 ? void 0 : _b.formattedValue) || '' }) : React.createElement(ProductPrice, { price: variantPrice || (product === null || product === void 0 ? void 0 : product.price) }))),
                !props.noSwatch && !product.isGiftCard && colorSelection(),
                !props.hidelabels && React.createElement(ProductLabels, { product: product, type: "tile-simplified", isMouseOver: showColorSwatch && isMouseOver }),
                props.showSizeSelection && (React.createElement(React.Fragment, null,
                    React.createElement(ProductSelectionSizes, { variationValues: sizeVariations, currentId: currentSize === null || currentSize === void 0 ? void 0 : currentSize.id, productId: product.uuid, onChangeVariation: (sizeVariation) => {
                            changeSize(sizeVariation);
                            setForceOpenSizeSelector(false);
                        }, isBoutiqueExclusive: product.isBoutiqueExclusive, open: forceOpenSizeSelector }),
                    justAddedMessage)))));
    };
    const getImageType = () => {
        if (props.forceStillLifeImage || props.type == 'SEARCH') {
            return 'F';
        }
        // PLP with rollover
        return props.noRollover || !isDesktop || !isOver ? 'X' : 'R';
    };
    const productName = () => {
        const Heading = (props.headingLevel ? props.headingLevel : 'h3');
        return (React.createElement(ProductLink, { isShelf: props.isShelf, noClickTracking: noClickTracking, index: props.index, product: product, tabIndex: props.disableFocus ? -1 : 0, linktype: props.type, pageType: props.pageType, className: "product-tile__link", recommender: props === null || props === void 0 ? void 0 : props.recommender, actionList: props.actionList, originalUuid: originalUuid },
            React.createElement(Heading, { "aria-hidden": props.type === 'LOOKPRODUCT', className: classNames('product-tile__name', {
                    'badge-card': (props.type == 'PLP' || props.type == 'RECS' || props.type == 'CURATORS') && (product === null || product === void 0 ? void 0 : product.unlock),
                }) }, product.productName)));
    };
    const isWhiteBg = useMemo(() => {
        return props.forceWhiteBg || (props.type === 'PLP' && (product === null || product === void 0 ? void 0 : product.imageBackground) === 'white') || (props.type !== 'PLP' && window.enableColorBackgroundStillLife);
    }, [props.type, product]);
    const tileCollection = () => {
        return (product.collections &&
            Object.keys(product.collections)
                .filter((item, i) => i == 0)
                .map((k) => {
                // eslint-disable-next-line jsx-a11y/anchor-has-content
                // with link: return <a key={k} href={product.collections[k]} className={`icon--${k}-white collection-in-tile`} aria-label={k} />;
                return (React.createElement("div", { key: k, className: "collection-in-tile" },
                    React.createElement("span", { className: `icon--${k}${!isWhiteBg ? '-white' : ''}` }),
                    React.createElement("span", { className: `visually-hidden ` }, t('product.incollection', { collectionName: k }))));
            }));
    };
    const tileMbm = () => {
        return (React.createElement("div", { className: "collection-in-tile" },
            React.createElement("span", { className: classNames({ 'icon-mbm': !isWhiteBg }, { 'icon-mbm-black': isWhiteBg }) }),
            React.createElement("span", { className: `visually-hidden ` }, t('product.incollection'))));
    };
    return (React.createElement("div", { "data-id": `${currentColor ? currentColor.productId : ''}${currentSize ? currentSize.id : ''}`, "data-product": product === null || product === void 0 ? void 0 : product.id, "data-productuuid": originalUuid, className: classNames('product-tile product-tile--simplified', 'single-slide__img', { 'white-bg': isWhiteBg }, { 'product-tile--carousel': props.type === 'RECS' || props.type === 'CURATORS' }, { 'in-search': props.type === 'SEARCH' }, { 'in-plp': props.type === 'PLP' }, { 'in-look': props.type === 'LOOKPRODUCT' }, { 'is-look': props.type === 'PLPLOOK' || props.type === 'LOOKTILE' }, { 'product-tile__with-carousel': isCarouselVersion }, { 'product-tile__swatch-change': props.type == 'PLP' && swatchChange && !props.forceStillLifeImage }), ref: tileRef, style: { paddingBottom: shopByLookHeight || lookProductInfoHeight }, onClick: triggerClick, onKeyDown: triggerClick },
        product ? (React.createElement(React.Fragment, null,
            React.createElement(DwMarker, { type: "product", uuid: product.uuid }),
            React.createElement(motion.div, { transition: getDefferedTransition(isDesktop ? (props.index < 4 ? 0 : 1) : props.index < 2 ? 0 : props.index < 4 ? 1 : 2, true), initial: { opacity: props.index < 8 ? 0 : 1 }, animate: { opacity: props.hasAnimation && !props.startAnimation ? 0 : 1 }, className: "product-tile__card" },
                props.type == 'LOOKTILE' ? (React.createElement("button", { className: classNames('look-toggle', { 'no-looks': ((_a = product.lookProducts) === null || _a === void 0 ? void 0 : _a.length) === 0 }, { 'no-cursor': (product === null || product === void 0 ? void 0 : product.isComingSoon) !== 1 }), onClick: (e) => {
                        var _a;
                        if (((_a = product.lookProducts) === null || _a === void 0 ? void 0 : _a.length) > 0 && (product === null || product === void 0 ? void 0 : product.isComingSoon) === 1) {
                            setOpenShopByLook(!openShopByLook);
                        }
                        else {
                            setShopByLookNotify(!shopByLookNotify);
                        }
                    } },
                    React.createElement("div", { className: "product-tile__image-wrapper" },
                        React.createElement(ProductImage, { productId: product.id, img: product.imgs, index: 0, className: "product-tile__image" })),
                    React.createElement("div", { className: "single-slide__labels" },
                        React.createElement("div", { className: "single-slide__title" }, t('product.looknbr', { n: Number(props.index) + 1 })),
                        isComingSoon ? (React.createElement("div", { className: "single-slide__coming-soon" }, t('product.nolook'))) : ((_b = product.lookProducts) === null || _b === void 0 ? void 0 : _b.length) > 0 && (product === null || product === void 0 ? void 0 : product.isComingSoon) === 1 ? (React.createElement("div", { className: "button button--tertiary-inverted button--arrow-right" },
                            React.createElement("div", { className: "single-slide__look" }, t('label.shopthelook')))) : null))) : props.type == 'PLPLOOK' ? (React.createElement(React.Fragment, null,
                    React.createElement(motion.div, { transition: getDefferedTransition(isDesktop ? (props.index < 4 ? 1 : 2) : props.index < 2 ? 1 : props.index < 4 ? 2 : 3), initial: { opacity: props.index < 8 ? 0 : 1 }, animate: { opacity: props.hasAnimation && !props.startAnimation ? 0 : 1 }, className: "look-number__wrapper" },
                        React.createElement("p", { className: "look-number" }, t('product.looknbr', { n: props.index + 1 })),
                        ((_c = product.lookProducts) === null || _c === void 0 ? void 0 : _c.length) === 0 ? (React.createElement("p", { className: "look-number" }, t('product.notavailable'))) : (isComingSoon && React.createElement("p", { className: "look-number" }, t('product.nolook')))),
                    React.createElement("button", { className: classNames('look-toggle', { 'no-looks': ((_d = product.lookProducts) === null || _d === void 0 ? void 0 : _d.length) === 0 }, { 'no-cursor': (product === null || product === void 0 ? void 0 : product.isComingSoon) !== 1 }), onClick: (e) => {
                            var _a, _b, _c;
                            if (shopByLookHeight == 0 && ((_a = product.lookProducts) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                                document.documentElement.style.scrollBehavior = 'smooth';
                                document.documentElement.scrollTop +=
                                    e.currentTarget.getBoundingClientRect().bottom -
                                        ((_b = document.querySelector('header')) === null || _b === void 0 ? void 0 : _b.offsetHeight) -
                                        ((_c = document.querySelector('.refine')) === null || _c === void 0 ? void 0 : _c.offsetHeight);
                                setTimeout(() => (document.documentElement.style.scrollBehavior = undefined), 500);
                                setShopByLookHeight(sbl.current.offsetHeight);
                                (props === null || props === void 0 ? void 0 : props.handleShopByLook) && props.handleShopByLook(true);
                            }
                            else {
                                setShopByLookHeight(0);
                                (props === null || props === void 0 ? void 0 : props.handleShopByLook) && props.handleShopByLook(false);
                            }
                        } },
                        React.createElement("div", { className: "product-tile__image-wrapper" },
                            React.createElement(ProductImage, { productId: product.id, img: product.imgs, index: 0, className: "product-tile__image" }))))) : (React.createElement("div", { className: "product-tile__image-wrapper", ref: containerRef }, props.customImage ? (React.createElement("img", { alt: product.productName, src: props.customImage, className: "custom_image" })) : isCarouselVersion ? (React.createElement(ProductTileCarousel, { img: product.imgs, productId: product.id, genderImageSorted: (_e = props.category) === null || _e === void 0 ? void 0 : _e.genderImageSorted, productUuid: originalUuid, isOver: isOver, imgQuality: props.type === 'PLP' && isMobile && 60, isSimplified: true, hideCarouselPagination: props.hideCarouselPagination })) : (React.createElement("div", null,
                    React.createElement(ProductImage
                    // style={{ transform: `scale(${imageTransformPercentage})` }}
                    , { 
                        // style={{ transform: `scale(${imageTransformPercentage})` }}
                        productId: product.id, img: product.imgs, tiletype: props.type, type: getImageType(), className: "product-tile__image", productUuid: originalUuid, animatedImage: props.type == 'PLP' }))))),
                tileCollection(),
                product.isMbm && tileMbm(),
                hoverDifferent && React.createElement("div", { className: "product-carousel__headline-hover" }, product.productName),
                introCards && (React.createElement("div", { className: "product-carousel__headline-hover" },
                    props.lookCarouselLabel && React.createElement("span", null, props.lookCarouselLabel),
                    React.createElement("h3", null, product.productName)))),
            props.type == 'LOOKTILE' ? (((_f = product.lookProducts) === null || _f === void 0 ? void 0 : _f.length) > 0 ? (React.createElement(ModalDialog, { hideHeader: true, noPadding: true, closeInvertedSm: true, className: "look-modal", isOpen: openShopByLook, onRequestClose: () => {
                    setOpenShopByLook(false);
                } },
                React.createElement(LookProduct, { noRedux: true, products: product.lookProducts, showLook: props.showLook, contactformurl: props === null || props === void 0 ? void 0 : props.contactformurl, title: t('product.looknbr', { n: Number(props.index) + 1 }) }))) : (React.createElement(ProductNotifyMeModal, { isOpen: shopByLookNotify, title: t('label.notifyme'), product: product, color: currentColor, size: currentSize, onRequestClose: () => setShopByLookNotify(false), from: 'look', inWishlist: false }))) : props.type == 'PLPLOOK' ? (((_g = product.lookProducts) === null || _g === void 0 ? void 0 : _g.length) > 0 && (React.createElement("div", { className: "shop-by-look-module", style: { height: shopByLookHeight, visibility: shopByLookHeight === 0 ? 'hidden' : 'visible' } },
                React.createElement("div", { ref: sbl, className: "container" },
                    React.createElement("button", { className: "icon--close close-shopbylook", onClick: () => {
                            setShopByLookHeight(0);
                            props === null || props === void 0 ? void 0 : props.handleShopByLook(false);
                        }, "aria-label": t('button.close') }),
                    React.createElement(LookProduct, { products: product.lookProducts, showLook: props.showLook }))))) : isDesktop || props.type == 'LOOKPRODUCT' ? (productInfo()) : (React.createElement(React.Fragment, null, productInfo())))) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "product-tile__card" },
                React.createElement("div", { className: "product-tile__link" },
                    React.createElement("div", { className: "product-tile__image-wrapper" },
                        React.createElement("div", { className: "product-image" })))),
            !props.hidelabels && (React.createElement("div", { className: "product-tile__info single-slide__labels" },
                React.createElement("p", { className: "product-tile__name" }, t('label.loading')),
                !props.hideprice && React.createElement("span", { className: "product-tile__price" }, t('label.loading')))))),
        showWishlistBtn && (React.createElement(ProductWishlistToggle, { color: isWhiteBg ? 'black' : 'white', productSize: currentSize, productColor: currentColor, product: productObject, section: props.type })),
        React.createElement(LoginModal, { reloadPage: true, incontext: "membersonly", modalStatus: loginOpen, updateStatus: (status) => setLoginOpen(status) })));
};
export default ProductTile;
